<template>
  <el-checkbox v-bind="$attrs"> <slot /> </el-checkbox>
</template>

<script>
export default {
  name: 'RtCheckbox'
};
</script>

<style></style>



// WEBPACK FOOTER //
// rtCheckbox.vue?14c4a50a